<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    Zgłoś polisę
  </div>

  <div   fxLayout="row" fxLayoutGap="15px">
<!--    <app-dict fxFlex="100" label="Rodzaj zgłoszenia"   [dictType]="'receivables_import_row_status'" [control]="statusControl" [required]="true"-->
<!--[onlyKeys]="[RECEIVABLES_IMPORT_ROW_STATUS_PAID_TO_TU,RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED]"-->
<!--    ></app-dict>-->
    <mat-form-field  fxFlex="100">
      <!--      <mat-label>Rodzaj   </mat-label>-->
      <mat-select
        [placeholder]="'Rodzaj zgłoszenia   '" [formControl]="statusKeyControl"
      >
        <mat-option [value]="RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED">Polisa anulowana</mat-option>
        <mat-option [value]="RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED">Polisa opłacona do TU</mat-option>

      </mat-select>
    </mat-form-field>

  </div>

  <div   fxLayout="row" fxLayoutGap="15px" *ngIf="cancelled === true || fileControl.value">
    <mat-form-field fxFlex="100">
      <mat-label *ngIf="statusKeyControl.value === RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED">Podaj powód anulowania</mat-label>
      <mat-label *ngIf="statusKeyControl.value === RECEIVABLES_IMPORT_ROW_STATUS_PAID_TO_TU">Podaj powód braku potwierdzenia przelewu</mat-label>
      <input [required]="cancelled ||  fileControl.value" matInput placeholder="Uwagi" [formControl]="noteControl" >
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" *ngIf="cancelled === false &&  !fileControl.value">

    <app-file-drag-and-drop
      fxFlex="100"
      [multiple]="false"
      [generateOutput]="true"
      (fileSelected)="fileSelected($event)"
      [required]="!cancelled"
      [maxSize]="fileMaxSize"
      acceptMime="*/*"
    ></app-file-drag-and-drop>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" *ngIf="cancelled === false">
    <div fxFlex="100">
      <mat-slide-toggle [formControl]="fileControl" color="accent">Nie posiadam potwierdzenia przelewu</mat-slide-toggle>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>


